import React from 'react';
import { motion } from 'framer-motion';
export function FamiliarSection() {
  return <section className="w-full bg-navy-darkest py-10 md:py-14" data-id="element-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-22">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-amber mb-2" data-id="element-23">
            Esto te suena familiar:
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="space-y-6 text-lg text-cream-muted leading-relaxed" data-id="element-24">
          <p data-id="element-25">
            Te acuestas agotada. Pero cuando apagas la luz, tu mente empieza.
          </p>

          <p data-id="element-26">
            Calculas horas. Repasas conversaciones. Inventas escenarios futuros.
            Te dices que{' '}
            <span className="text-cream italic" data-id="element-27">
              "mañana vas a estar fatal"
            </span>
            .
          </p>

          <p data-id="element-28">Miras el reloj.</p>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="text-center py-4" data-id="element-29">
            <p className="font-playfair text-2xl md:text-3xl text-amber font-bold" data-id="element-30">
              2:18 AM. &nbsp; 2:37 AM. &nbsp; 3:12 AM.
            </p>
          </motion.div>

          <p data-id="element-31">Y cada minuto despierta aumenta la ansiedad.</p>

          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="text-xl text-cream font-medium text-center pt-4" data-id="element-32">
            Si esto es tu noche, sigue leyendo.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}